export default "__VITE_ASSET__BT7f4cDw__"